module.exports = __webpack_public_path__ + "img/invoice1.89d3e003.png";